<template>
  <div>
    <router-view/>
    <loadingPage v-if="$store.state.Action.loading"/>
  </div>
</template>

<script>
import LoadingPage from '@/components/loadingpage.vue'
export default {
  name: 'App',
  components: {
    LoadingPage
  }
}
</script>

<style>
a { text-decoration: none; }
</style>



// WEBPACK FOOTER //
// src/App.vue